import React, { useEffect, useState } from "react";
import { LockKeyhole } from "lucide-react";
import { Btn, ErrorNote, Input } from "@/components/kmt/ui";
import { SITE_PASS_KEY, errMsg, publicApi } from "@/lib/api";

export default function SiteGate({ children }: { children: React.ReactNode }) {
  const [state, setState] = useState<"checking" | "locked" | "open">("checking");
  const [pin, setPin] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(SITE_PASS_KEY)) {
      setState("locked");
      return;
    }
    publicApi.get("/site/check").then(() => setState("open")).catch(() => {
      localStorage.removeItem(SITE_PASS_KEY);
      setState("locked");
    });
  }, []);

  const unlock = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try {
      const r = await publicApi.post("/site/unlock", { pin });
      localStorage.setItem(SITE_PASS_KEY, r.data.pass);
      setState("open");
    } catch (e2) {
      setErr(errMsg(e2));
      setPin("");
    } finally {
      setBusy(false);
    }
  };

  if (state === "open") return <>{children}</>;
  if (state === "checking") return <div className="min-h-screen bg-ink" />;
  return (
    <div className="grain relative grid min-h-screen place-items-center bg-ink px-5 font-body text-mist" data-testid="site-gate">
      <form onSubmit={unlock} className="rise relative z-10 w-full max-w-sm rounded-md border border-gold/30 bg-aubergine/80 p-8 text-center backdrop-blur-xl">
        <span className="mx-auto grid h-16 w-16 place-items-center rounded-full border border-gold/70 text-gold"><LockKeyhole size={26} /></span>
        <p className="eyebrow mt-6">KMT Private Rides</p>
        <h1 className="mt-3 font-display text-3xl text-gold">Coming soon</h1>
        <p className="mt-3 text-[15px] text-mist/80">Enter the PIN to preview the site.</p>
        <label htmlFor="site-pin" className="sr-only">PIN code</label>
        <Input id="site-pin" type="password" inputMode="numeric" autoComplete="off" maxLength={12} value={pin} onChange={(e) => setPin(e.target.value)}
          className="mt-6 text-center text-xl tracking-[0.5em]" data-testid="site-gate-pin-input" autoFocus />
        <div className="mt-4"><ErrorNote msg={err} /></div>
        <Btn type="submit" disabled={busy || !pin} className="mt-4 w-full" data-testid="site-gate-submit-btn">{busy ? "Checking…" : "Enter"}</Btn>
      </form>
    </div>
  );
}
